import styled from 'react-emotion'
import { padding } from 'stylist'

const InfoGroup = styled.div`
  ${padding('xxs')};
`
export default InfoGroup



// WEBPACK FOOTER //
// ./src/components/InfoGroup.js